(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-alm-product]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const data = JSON.parse(root.querySelector('[data-alm-product-json]')?.textContent || '{}');
      const form = document.getElementById(root.dataset.formId);
      const offers = [...root.querySelectorAll('[data-alm-offer]')];
      const planSelector = root.querySelector('[data-alm-selling-plan]');
      const sticky = root.querySelector('[data-alm-sticky]');
      const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: root.dataset.currency || 'USD' });
      const money = cents => formatter.format(Number(cents || 0) / 100);
      const byId = id => data.variants?.find(v => String(v.id) === String(id));
      let variant = byId(offers.find(o => o.checked)?.value || form?.elements.namedItem('id')?.value);
      const refreshPrice = () => {
        offers.forEach(offer => {
          const item = byId(offer.value);
          if (!item) return;
          const row = offer.closest('[data-alm-offer-row]');
          row.querySelector('[data-alm-offer-price]').textContent = money(item.price);
          const compare = row.querySelector('[data-alm-offer-compare]');
          compare.hidden = !(item.compare_at_price > item.price);
          compare.textContent = money(item.compare_at_price);
        });
        const disabled = !variant?.available || (data.requires_selling_plan && !planSelector?.value) || form?.getAttribute('aria-busy') === 'true';
        const label = variant?.available ? data.strings.add : data.strings.soldOut;
        if (data.variants?.length) root.querySelectorAll('[data-alm-add-label], [data-alm-sticky-label]').forEach(el => el.textContent = label);
        root.querySelectorAll('[data-alm-add], [data-alm-sticky]').forEach(el => el.disabled = disabled);
      };
      const refreshVariant = (updateUrl = false) => {
        if (!variant) { refreshPrice(); return; }
        offers.forEach(o => o.checked = String(variant.id) === o.value);
        const quantity = form?.querySelector('[name="quantity"]');
        if (quantity) quantity.value = String(Math.max(1, Number(variant.quantity_rule?.min) || 1));
        if (planSelector) {
          const selectedId = planSelector.value;
          planSelector.replaceChildren();
          (variant.selling_plan_allocations || []).forEach(allocation => {
            const option = document.createElement('option');
            option.value = String(allocation.id);
            option.textContent = allocation.name + ' — ' + money(allocation.price);
            option.selected = String(allocation.id) === selectedId;
            planSelector.append(option);
          });
        }
        if (updateUrl && location.pathname.includes('/products/')) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }
        refreshPrice();
      };
      offers.forEach(offer => offer.addEventListener('change', () => { variant = byId(offer.value); refreshVariant(true); }));
      planSelector?.addEventListener('change', refreshPrice);
      sticky?.addEventListener('click', () => {
        const submitter = form?.querySelector('[data-alm-add]');
        if (submitter && !submitter.disabled) { form._almeoraTrigger = sticky; form.requestSubmit(submitter); }
      });
      form?.addEventListener('almeora:form-idle', refreshPrice);
      const restoreVariant = () => {
        const selected = byId(new URL(location.href).searchParams.get('variant'));
        if (selected && offers.some(o => o.value === String(selected.id))) variant = selected;
        refreshVariant();
      };
      restoreVariant();
      window.addEventListener('popstate', restoreVariant);
      const delivery = root.querySelector('[data-alm-delivery]');
      if (delivery) {
        const dates = [4,7].map(days => { const d = new Date(); d.setDate(d.getDate()+days); return d.toLocaleDateString('en-US',{weekday:'long',month:'long',day:'numeric'}); });
        delivery.textContent = `Delivered between ${dates[0]} and ${dates[1]}`;
      }

      const gallery = root.querySelector('[data-alm-gallery]');
      const panels = [...gallery.querySelectorAll('[data-alm-panel]')];
      const thumbs = [...gallery.querySelectorAll('[data-alm-thumb]')];
      const previous = gallery.querySelector('[data-alm-gallery-prev]');
      const next = gallery.querySelector('[data-alm-gallery-next]');
      let active = 0;
      const showImage = (index, focusThumb = false) => {
        active = Math.max(0, Math.min(panels.length - 1, index));
        panels.forEach((panel, i) => { panel.hidden = i !== active; if (i !== active) panel.querySelectorAll('video').forEach(v => v.pause()); });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === active)));
        previous.disabled = active === 0;
        next.disabled = active === panels.length - 1;
        if (focusThumb) thumbs[active]?.focus();
      };
      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => showImage(index));
        thumb.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          showImage(event.key === 'Home' ? 0 : event.key === 'End' ? panels.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1), true);
        });
      });
      previous.addEventListener('click', () => showImage(active - 1));
      next.addEventListener('click', () => showImage(active + 1));
      let startX = null, startY = null;
      const stage = gallery.querySelector('.alm-gallery-stage');
      stage.addEventListener('touchstart', event => { startX = event.changedTouches[0].clientX; startY = event.changedTouches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', event => {
        if (startX === null) return;
        const dx = event.changedTouches[0].clientX - startX;
        const dy = event.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) showImage(active + (dx < 0 ? 1 : -1));
        startX = null;
      }, { passive: true });
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => initialize()) : initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
